import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { useReturnStore } from '@src/stores/returnStore';
import {
  PTC_REFUND_TIMING_MESSAGE,
  REFUND_TIMING_MESSAGE,
} from '@src/constants';
import { GuestRefundMethod, NonGuestRefundMethod } from './RefundMethodHelper';

const RefundMethods = () => {
  const tenders = useReturnStore((state) => state.tenders);
  const orderDetailsV2 = useReturnStore((state) => state.orderDetailsV2);
  const isPTCOrder = useReturnStore((state) => state.isPTCOrder);
  const isMilitaryExchangeGuest = useReturnStore(
    (state) => state.isMilitaryExchangeGuest,
  );

  // BED responds with MM/YYYY
  const expDate =
    orderDetailsV2?.paymentMethods?.[0]?.creditCardExpDate ||
    tenders?.[0]?.expiration;

  const refundTimingMessage = isPTCOrder
    ? PTC_REFUND_TIMING_MESSAGE
    : REFUND_TIMING_MESSAGE;

  return (
    <div className="sui-flex sui-flex-col">
      {isMilitaryExchangeGuest ? (
        <GuestRefundMethod />
      ) : (
        <NonGuestRefundMethod tenders={tenders} expDate={expDate} />
      )}
      <div className="sui-mt-3">
        <Typography variant="body-xs">{refundTimingMessage}</Typography>
      </div>
    </div>
  );
};

export default RefundMethods;
